import React, {useEffect, useState} from 'react';
import {Box, Typography} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {useSelector} from 'react-redux';

import {RootState} from 'appredux/reducers';
import {apiGetSatelliteRisks, ISatelliteRisk} from 'constants/Api';

export default function FarmRisksWidget() {
  const userId = Number(
    useSelector(
      (s: RootState) => (s.user as any)?.id || (s.user as any)?.userId || 0,
    ),
  );

  const [risks, setRisks] = useState<ISatelliteRisk[]>([]);
  const [loading, setLoading] = useState(true);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    if (!userId) return;
    apiGetSatelliteRisks(userId)
      .then((data) => {
        const top5 = [...data]
          .sort((a, b) => b.riskCount - a.riskCount)
          .slice(0, 5);
        setRisks(top5);
      })
      .catch(() => {
        /* backend query not yet deployed — show placeholder instead of crash */
        setUnavailable(true);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  return (
    <Box display="flex" flexDirection="column">
      <Typography className="widget-heading">SATELLITE RISKS</Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        style={{marginBottom: 8}}
      >
        Top 5 farmers ranked by number of risks
      </Typography>

      {loading ? (
        Array.from({length: 5}).map((_, i) => (
          <Skeleton key={i} variant="text" height={28} />
        ))
      ) : unavailable ? (
        <Typography variant="body2" color="textSecondary">
          Satellite risk data is not yet available.
        </Typography>
      ) : risks.length === 0 ? (
        <Typography variant="body2" color="textSecondary">
          No satellite risks found
        </Typography>
      ) : (
        risks.map((row, index) => (
          <Box
            key={row.applicationId}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            {/* Rank badge */}
            <Typography
              variant="caption"
              style={{
                fontWeight: 700,
                minWidth: 20,
                color: index === 0 ? '#c62828' : '#757575',
              }}
            >
              #{index + 1}
            </Typography>

            {/* Farmer / farm name */}
            <Box flex={1} mx={1}>
              <Typography variant="body2">{row.farmerName}</Typography>
              <Typography variant="caption" color="textSecondary">
                {row.farmName}
              </Typography>
            </Box>

            {/* Risk count */}
            <Typography variant="body2">
              <strong>{row.riskCount}</strong>
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
}
